import { onCLS, onINP, onLCP, onFCP, onTTFB } from 'web-vitals';

function sendTo(path, body) {
    const url = `${window.location.origin}${path}`;
    const blob = new Blob([JSON.stringify(body)], { type: 'application/json' });

    if (navigator.sendBeacon) {
        navigator.sendBeacon(url, blob);
    } else {
        fetch(url, {
            method: 'POST',
            body: JSON.stringify(body),
            headers: { 'Content-Type': 'application/json' },
            keepalive: true,
        }).catch(() => {});
    }
}

function vitalsPayload(metric) {
    return {
        name: metric.name,
        id: metric.id,
        value: metric.value,
        rating: metric.rating,
        path: location.pathname + location.search,
        href: location.href,
        ts: Date.now(),
    };
}

const SAMPLE_RATE = 1.0;
const shouldSend = Math.random() < SAMPLE_RATE;

const envMeta = document.querySelector('meta[name="app-environment"]');
const APP_ENV = envMeta?.content || 'production';
const IS_PROD = APP_ENV === 'production';

if (shouldSend) {
    const endpoint = '/api/web-vitals';

    const handler = (metric) => {
        const data = vitalsPayload(metric);

        if (IS_PROD) {
            // sendTo(endpoint, data);
        } else {
            const color =
                metric.rating === 'good'
                    ? 'color: #22c55e'
                    : metric.rating === 'needs-improvement'
                    ? 'color: #eab308'
                    : 'color: #ef4444';

            console.groupCollapsed(
                `%cWeb Vital: ${metric.name} → ${metric.value.toFixed(2)} ms (%c${metric.rating}%c)`,
                'color:#3b82f6;font-weight:bold',
                color,
                'color:inherit'
            );
            console.log(data);
            console.groupEnd();
        }
    };

    onLCP(handler);
    onCLS(handler);
    onINP(handler);
    onFCP(handler);
    onTTFB(handler);
}
